export default {
  currentUser: {
    key: ['currentUser'],
    path: 'profile',
  },
}
